import React from "react";

export const getIcon = (iconName: string, style: React.CSSProperties = {}): JSX.Element => (
  <i className="icon" style={{ ...style }}>
    <img width={"100%"} height={"20px"} src={iconName} />
  </i>
);
